import React, { useEffect, useState } from 'react';
import { ReactComponent as BackLeftSvg } from '../../assets/svg/back-left.svg';
import {BorderBox2} from '../BorderBox/index.jsx';
import { useRoot } from '../../hooks/useRoot.jsx';
import { addNewLayout, getAllImgByProId, getCheckLayoutResult } from '../../api/request.js';
import { PCIMGARY, PCLAYOUTID, PCPROID, PCPSTEP, PCROWCOL } from '../../utils/utils.ts';

const ResultCom = () => {
  const { rowCol, curProId, setCurLayoutId, setStep, setRowCol, setOtherProId, setCurProId } = useRoot();
  const [ resultList, setResultList ] = useState([]);

  useEffect(() => {
    const fnTest = async () => {
      const result = await getAllImgByProId(curProId, false);
      if(result.status === 'Success') {
        const layoutIds = result.data.map(item => item.layoutid);
        const requestList = [];
        layoutIds.forEach(element => {
          requestList.push(getCheckLayoutResult(element));
        });
        const tempResult = [];
        const resultList = await Promise.all(requestList);
        resultList.forEach(item => {
          if(item.status === 'Success') {
            if(item.data.images.length > 0) {
              tempResult.push(item.data);

              const { rows = 4, columns = 5} = item.data;
              const rowCol = {
                row: rows,
                col: columns
              };
              setRowCol(rowCol);
              sessionStorage.setItem(PCROWCOL, JSON.stringify(rowCol));
            }
          }
        });
        setResultList(tempResult);
      }
    };
    fnTest();
  }, [curProId]);

  const fnNewLayout = async () => {
    try {
      const { col: colNum, row: rowNum } = rowCol;
      const params = {
        projectid: curProId,
        columns: colNum,
        rows: rowNum,
        is_share: 'true'
      };
      const layoutResult = await addNewLayout(params);
      if(layoutResult.status === 'Success') {
        setCurLayoutId(layoutResult.data.layoutid);
        setStep(2);
      }
    } catch(error) {
      console.error('Error creating new layout:', error);
    }
  };

  const fnNewProject = () => {
    setStep(1);
    setRowCol({
      row: 0,
      col: 0
    });
    setOtherProId('');
    setCurProId('');
    sessionStorage.removeItem(PCPROID);
    sessionStorage.removeItem(PCLAYOUTID);
    sessionStorage.removeItem(PCPSTEP);
    sessionStorage.removeItem(PCROWCOL);
    sessionStorage.removeItem(PCIMGARY);
  };

  return <>
    <div className='flex-1 flex flex-col bg-black h-0'>
      <div className='h-[50px] w-full px-[25px] flex justify-start items-center bg-[#00A32E]'>
        <BackLeftSvg></BackLeftSvg>
        <span className='text-sm font-bold ml-3 cursor-pointer'>Attrect: Visual Hierarchy</span>
      </div>
      <div className='flex-1 p-[30px] py-[15px] w-full flex flex-col justify-start items-start h-0'>
        <div className='flex items-center w-full'>
          <div className='w-[150px]'></div>

          <div className='flex-1 flex items-center justify-center text-white text-[14px] bg-[#013B02] h-[35px]'>
            Shelf Layout
          </div>
          <div className='w-[30px]'></div>
          <div className='flex-1 flex items-center justify-center text-white text-[14px] bg-[#013B02] h-[35px]'>
            Heatmap
          </div>
          <div className='w-[30px]'></div>
          <div className='flex-1 flex items-center justify-center text-white text-[14px] bg-[#013B02] h-[35px]'>
            Hotspots
          </div>
        </div>

        <div className='w-full flex-1 overflow-y-auto mb-5 h-0'>
          {
            resultList.map((item, index) => <div key={index}>
              <div className='flex items-center w-full my-5'>
                <div className='w-[150px] flex justify-end items-center'>
                  <BorderBox2>
                    <div className='text-[#00FF48CC] text-[12px] font-bold w-[100px] h-[35px] flex justify-center items-center'>Layout {index + 1}</div>
                  </BorderBox2>
                </div>

                <div className='flex-1 flex items-center justify-center'>
                  <img
                    src={item.image_path}
                    className='w-[80%]'
                  ></img>
                  {/* aspect-[16/9] */}
                </div>
                <div className='w-[30px]'></div>
                <div className='flex-1 flex items-center justify-center'>
                  <img
                    src={item.heatmapimage}
                    className='w-[80%]'
                  ></img>
                  {/* aspect-[16/9] */}
                </div>
                <div className='w-[30px]'></div>
                <div className='flex-1 flex items-center justify-center'>
                  <img
                    src={item.hotpotimage}
                    className='w-[80%]'
                  ></img>
                  {/* aspect-[16/9] */}
                </div>
              </div>
              {
                resultList.length - 1 !== index && <div className='h-[2px] w-full' style={{background: 'linear-gradient(90deg, #030F07, #00A32E 50%, #030F07)'}}></div> 
              }
            </div>)
          }
        </div>

        <div className='w-full flex justify-center items-center'>
          <div onClick={fnNewLayout} className='cursor-pointer w-[200px] h-[40px] rounded text-white bg-[#003B00] font-bold text-[16px] flex justify-center items-center'>Test another Layout</div>
          <div className='w-[30px]'></div>
          <div onClick={fnNewProject} className='cursor-pointer w-[200px] h-[40px] rounded text-white bg-[#00A32E] font-bold text-[16px] flex justify-center items-center'>Start a New Test</div>
        </div>
      </div>
    </div>
  </>;
};

export default ResultCom;